import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//

import { exportExcel } from "@/api/data";
export default {
  name: "ExcelExport",
  components: {},
  props: {
    type: {
      type: String,
      require: true,
      default: ""
    },
    date: {
      type: [Array, null],
      require: true,
      default: null
    },
    request: {
      type: Function,
      default: null,
      require: false
    },
    extraParams: {
      type: Object,
      default: null,
      require: false
    }
  },
  methods: {
    submitExportExcel: function submitExportExcel() {
      var params = _objectSpread({
        data_type: this.type,
        language: this.$i18n.locale === "zh" ? "cn" : "en"
      }, this.extraParams);
      if (this.date) {
        params.former_time = this.date[0];
        params.latter_time = this.date[1];
      }
      var request = this.request || exportExcel;
      request(params);
    }
  }
};